import React, { Component } from "react";
import './personalloanads.css';

class PersonalLoanforRenovate extends Component {
  render() {
    return (
      <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="/home" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">เงินกู้พิเศษเพื่อการเคหสงเคราะห์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="/personalloanforrenovate" className="a-breadcrumbs">เงินกู้พิเศษเพื่อการเคหสงเคราะห์-ซ่อมแซมที่อยู่อาศัย</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{width: '90%', fontFamily: '"Cordia New"'}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>เงินกู้พิเศษเพื่อการเคหสงเคราะห์ เพื่อซ่อมแซมที่อยู่อาศัย </span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>วัตถุประสงค์</th>
                      <th>วงเงินกู้</th>
                      <th style={{width: 100}}>งวดชำระ</th>
                      <th style={{width: 200}}>หลักประกัน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>เพื่อซ่อมแซมที่อยู่อาศัยบนที่ดินของสมาชิก หรือ สมาชิกและคู่สมรส (ปลอดภาระจำนอง)
                      </td>
                      <td>90% ของราคาประเมินบ้านพร้อมที่ดิน<br />
                        50% ของราคาประเมินที่ดิน<br />
                        100% ของมูลค่าหุ้นและ/หรือเงินฝาก ที่ไม่ติดภาระ<br />
                        วงเงินไม่เกิน 500,000 บาท ทุกหลักทรัพย์
                      </td>
                      <td rowSpan={2}>ไม่เกิน120 งวด
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>โฉนดที่ดิน</li>
                          <li>หุ้นและ/หรือเงินฝากที่มีอยู่กับสหกรณ์</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>เพื่อซ่อมแซมที่อยู่อาศัยบนที่ดินของสมาชิก หรือ สมาชิกและคู่สมรส (ติดภาระจำนองกับสหกรณ์)
                      </td>
                      <td>วงเงินกู้รวมหนี้คงเหลือไม่เกิน90% ของราคาประเมิน บ้านพร้อมที่ดิน แต่ไม่เกิน 500,000 บาท
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>โฉนดที่ดิน</li>
                          <li>ประกันชีวิต</li>
                          <li>ประกันทุพพลภาพ</li>
                          <li>ประกันอัคคีภัยและภัยพิบัติ</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <tbody>
                    <tr>
                      <td style={{width: 170}}>เงื่อนไข
                      </td>
                      <td colSpan={2}>
                        <ul className="mb-25">
                          <li>1. ผู้กู้ต้องมีอายุงานตั้งแต่ 1 ปีขึ้นไป</li>
                          <li>2. วัตถุประสงค์ของการกู้
                            <ul className="mb-25">
                              <li>เพื่อซ่อมแซมที่อยู่อาศัย บนบ้านพร้อมที่ดินที่เป็นชื่อของสมาชิก หรือชื่อสมาชิกและคู่สมรส</li>
                              <li>เพื่อไถ่ถอนบ้านและที่ดินที่เป็นชื่อของสมาชิก หรือชื่อสมาชิกและคู่สมรส และซ่อมแซมที่อยู่อาศัย</li>
                            </ul>
                          </li>
                          <li>3. หลักทรัพย์อยู่ในเขตจังหวัดชลบุรี ระยอง กรุงเทพมหานครและปริมณฑล  ฉะเชิงเทรา นครนายก อยุธยา สระบุรี สุพรรณบุรี จันทบุรี ปราจีนบุรี </li>
                          <li>4. จำนวนเงินที่ผ่อนชำระเงินคืนเงินกู้ประเภทดังกล่าว ให้นำมาคิดรวมกับการคำนวณ 50% Take Hom</li>
                          <li>5. สมาชิกจะกู้เงินพิเศษเคหสงเคราะห์ได้มากกว่า 1 ประเภทประเภทละ 1 สัญญา สมาชิก 1 ราย จะกู้ได้ไม่เกิน 2 สัญญาและรวมกัน 2 สัญญา วงเงินกู้ต้องไม่เกิน 10 ล้านบาท</li>
                          <li>7. สามารถขยายการคำนวนงวดผ่อนชำระไปจนถึงอายุ 65 ปี แต่ต้องชำระหนี้คืนทั้งจำนวน เมื่ออายุ 60 ปี หรือสิ้นสุดการเป็นพนักงาน</li>
                          <li>8. ผู้กู้จะต้องทำประกันภัยอัคคีภัยและภัยพิบัติสิ่งปลูกสร้างทั้งหมดโดยมีวงเงินเอาประกันไม่น้อยกว่ามูลค่าทรัพย์สินที่ปลูกสร้าง พร้อมทั้งทำประกันชีวิต ในวงเงินเอาประกันไม่น้อยกว่าจำนวนเงินกู้ที่ยังค้างชำระรวมดอกเบี้ยที่เกิดขึ้นทั้งหมด โดยให้สหกรณ์เป็นผู้รับผลประโยชน์ และผู้กู้เป็นผู้รับผิดชอบค่าเบี้ยประกันทั้งสิ้นแต่เพียงฝ่ายเดียว</li>
                          <li>9. หลักทรัพย์ที่นำมาค้ำประกันการกู้เพื่อซ่อมแซมที่อยู่อาศัยของสมาชิกต้องอยู่เป็นที่อยู่อาศัยในปัจจุบัน หรืออยู่ในพื้นที่เดียวกับที่อยู่อาศัย</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>ขั้นตอน
                      </td>
                      <td colSpan={2}>
                        <ul className="mb-25">
                          <li>1. ผู้กู้ติดต่อบริษัทประเมินทรัพย์สิน  ดังนี้
                            <ul className="mb-25">
                              <li><b>บริษัท โกลเด้น แอนด์ แอพเพรซัล จำกัด</b> <a href="Form/ค่าบริการ(บ.โกลเด้น).pdf" target="_blank" style={{color: '#4db6f1'}}><b>&gt;&gt;อัตราค่าบริการ&lt;&lt;</b></a>
                                <br />
                                คุณรุ่งเพชร สร้อยรัก (หมู)  
                                <br />
                                โทรศัพท์ 081-9084241
                              </li>
                              <li><b>บริษัท แอดวานซ์ แอพไพรซัล จำกัด</b> <a href="Form/ค่าบริการ(บ.แอดวานซ์).pdf" target="_blank" style={{color: '#4db6f1'}}><b>&gt;&gt;อัตราค่าบริการ&lt;&lt;</b></a>
                                <br />
                                คุณพิมทอง พัฒโนทัย (นก)  
                                <br />
                                โทรศัพท์ 086-3185026
                              </li>
                              <li><b>บริษัท กรุงสยามประเมินทรัพย์สิน จำกัด</b> <a href="Form/ค่าบริการ(บ.กรุงสยาม).pdf" target="_blank" style={{color: '#4db6f1'}}><b>&gt;&gt;อัตราค่าบริการ&lt;&lt;</b></a>
                                <br />
                                คุณแอน
                                <br />
                                โทรศัพท์ 099-2196400
                              </li>
                              <li><b>บริษัท กวินแอพเพรซัล จำกัด</b> <a href="Form/ค่าใช้จ่ายประเมิน-กวิน.pdf" target="_blank" style={{color: '#4db6f1'}}><b>&gt;&gt;อัตราค่าบริการ&lt;&lt;</b></a>
                                <br />
                                คุณฟาติมา 
                                <br />
                                โทรศัพท์ 097-2513423
                                <br />
                                <u>เพื่อประเมินมูลค่าที่ดินและสิ่งก่อสร้าง การประเมินราคาหลักทรัพย์ ผู้กู้เป็นผู้ออกค่าใช้จ่ายเอง  ระยะเวลาจัดทำเอกสารประเมินประมาณ 7-10 วันทำการ</u>
                              </li>
                            </ul>
                          </li>
                          <li>2. ยื่นคำขอกู้ผ่านทาง ระบบข้อมูลสมาชิกออนไลน์</li>
                          <li>3. รอบการกู้มี 2 รอบ  ยื่นกู้   </li>
                          <li>&nbsp;&nbsp;&nbsp;ภายในวันที่ 1 ของแต่ละเดือน รอบการรับเงิน วันที่ 16 </li>
                          <li>&nbsp;&nbsp;&nbsp;ภายในวันที่ 15 ของแต่ละเดือน รอบการรับเงิน วันที่ 1 ของเดือนถัดไป </li>
                          <li>4. ผู้กู้ส่งคำขอกู้ เอกสารการประเมินทรัพย์สิน และเอกสารประกอบภายในเวลาที่กำหนด</li>
                          <li>5. คณะอนุกรรมการฯ จะพิจารณาอนุมัติเงินกู้เมื่อเอกสารครบถ้วน  เมื่อได้รับการอนุมัติ สหกรณ์จะแจ้งผลทาง E-mail ขอให้สมาชิกติดต่อเพื่อยืนยันการสั่งจ่ายเช็ค</li>
                          <li>6. สหกรณ์จะจ่ายเงินกู้เป็นเช็คในชื่อสมาชิกในวันทำสัญญา หรือวันทำสัญญาและจดจำนอง</li>
                          <li>7. สหกรณ์จะจ่ายเงินกู้เป็นงวด งวดแรก 50% ของวงเงินอนุมัติ งวดที่สองอีก 50% จ่ายเมื่องานแล้วเสร็จสมบูรณ์ ผู้กู้จะต้องเบิกเงินงวดภายในระยะเวลาไม่เกิน 3 เดือนนับจากวันทำสัญญา และรับเงินงวดแรก</li>
                          <li>8. หากการจำนองไม่สำเร็จด้วยปัญหาใดๆ ก็ตาม สมาชิกจะต้องจ่ายดอกเบี้ยตามจำนวนวันที่ได้รับเงินไปก่อนการทำจำนอง และนำเช็คมาคืนเข้าบัญชีสหกรณ์ภายในวันเดียวกัน</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>การนัดวันจดจำนองและค่าใช้จ่าย
                      </td>
                      <td colSpan={2}>
                        <ul className="mb-25">
                          <li>ผู้กู้จะต้องนัดหมายรับเจ้าหน้าที่ ณ ที่ทำการสหกรณ์ เพื่อไปทำจำนอง ทั้งในเขตพื้นที่ชลบุรี และนอกเขตฯ หากมีผู้กู้ต้องไปทำจำนอง ณ สำนักงานที่ดินเดียวกันมากกว่าหนึ่งราย ให้ผู้ขอกู้ตกลงกับเจ้าหน้าที่เป็นรายๆ ไป</li>
                          <li>ค่าใช้จ่ายในการทำจำนองที่สมาชิกต้องรับผิดชอบ มีดังนี้
                            <ul className="mb-25">
                              <li>ค่าเช่ารถ กรณี ผู้กู้ไม่สามารถมารับเจ้าหน้าที่ไปทำจำนองได้</li>
                              <li>เบี้ยเลี้ยงการปฏิบัติงานนอกพื้นที่ 150 บาท (กรณีทำจำนองนอกเขตพื้นที่จังหวัดชลบุรี)</li>
                              <li>ค่าธรรมเนียมที่สหกรณ์เรียกเก็บ สหกรณ์ออกใบเสร็จรับเงิน
                                <ul className="mb-25">
                                  <li>บ้านพร้อมที่ดินและที่ดินเปล่า 80 บาท </li>
                                  <li>ห้องชุด 60 บาท</li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                          <li>สหกรณ์กำหนดทำจำนองทุกวันพฤหัสบดี (ตารางทำจำนองบนหน้า Home) สมาชิกจะต้องนัดหมายวันทำจำนองและวันรับเช็คกับสหกรณ์ก่อนนัดหมายกับบุคคลที่เกี่ยวข้องภายนอก ในการทำจำนองครั้งหนึ่งๆ จะไม่เกิน 5-7 ราย ขึ้นอยู่กับความซับซ้อนในการทำจำนอง</li>
                          <li>วันทำจำนองผู้กู้และคู่สมรสต้องนำบัตรประจำตัวประชาชนและทะเบียนบ้านตัวจริงไปด้วยทุกครั้ง</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>เอกสารประกอบการยื่นกู้
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>สำเนาบัตรประจำตัวประชาชน ผู้กู้</li>
                          <li>สำเนาทะเบียนบ้าน ผู้กู้ (ผู้กู้ต้องมีชื่ออยู่ในทะเบียนบ้านมากกว่า 1 ปีขึ้นไป)</li>
                          <li>สำเนาบัตรใบเปลี่ยนชื่อ – สกุล ผู้กู้ (ถ้ามี)</li>
                          <li>สำเนาบัตรประจำตัวประชาชนและสำเนาทะเบียนบ้าน คู่สมรสผู้กู้ พร้อมรับรองสำเนาถูกต้องโดยคู่สมรสผู้กู้ (ถ้ามี)</li>
                          <li>สำเนาบัตรใบเปลี่ยนชื่อ – สกุล คู่สมรสผู้ขอกู้ พร้อมรับรองสำเนาถูกต้องโดยคู่สมรสผู้ขอกู้ (ถ้ามี)</li>
                          <li>สำเนาทะเบียนสมรส หรือสำเนาทะเบียนหย่า (ถ้ามี)</li>
                          <li>สำเนาโฉนดที่ดิน (ทุกหน้า)</li>
                          <li>สำเนาหนังสือขออนุญาตก่อสร้างอาคารที่จะทำการปลูกสร้าง</li>
                          <li>สำเนาหนังสือสัญญาเงินกู้ และสัญญาจำนอง (กรณีชำระหนี้เงินกู้ธนาคาร)</li>
                          <li>สำเนาใบเสร็จรับเงินการผ่อนชำระงวดล่าสุด (กรณีชำระหนี้เงินกู้ธนาคาร)</li>
                          <li>รายละเอียดวัสดุอุปกรณ์ในงานซ่อมแซม ราคา พร้อมระยะเวลาดำเนินงาน</li>
                          <li>ภาพถ่ายรายละเอียดของที่อยู่อาศัยพร้อมทั้งบริเวณที่จะดำเนินการซ่อมแซม</li>
                          <li>สำเนาเอกสารผลการตรวจสุขภาพประจำปี (เพื่อการทำประกันชีวิตคุ้มครองเงินกู้  กรณีวงเงินกู้เคหะทุกประเภทรวมกันเกิน 1.5 ล้านบาทขึ้นไป)</li>
                          <li><u>ผู้กู้ลงนามรับรองสำเนาถูกต้องทุกฉบับ ระบุ ใช้เพื่อเป็นเอกสารประกอบการยื่นกู้ต่อสหกรณ์ออมทรัพย์ไทยออยล์ จำกัด เท่านั้น</u></li>
                        </ul>
                      </td>
                      <td style={{width: 70}}>1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด
                      </td>
                    </tr>
                    <tr>
                      <td>เอกสารประกอบการทำจำนอง
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>สำเนาบัตรประจำตัวประชาชนและสำเนาทะเบียนบ้าน ผู้กู้</li>
                          <li>สำเนาบัตรใบเปลี่ยนชื่อ – สกุล ผู้กู้ (ถ้ามี)</li>
                          <li>สำเนาบัตรประจำตัวประชาชนและสำเนาทะเบียนบ้าน คู่สมรสผู้กู้ (ถ้ามี)</li>
                          <li>สำเนาบัตรใบเปลี่ยนชื่อ – สกุล คู่สมรสผู้กู้ (ถ้ามี)</li>
                          <li>สำเนาทะเบียนสมรส หรือสำเนาทะเบียนหย่า (ถ้ามี)</li>
                          <li>หนังสือยินยอมของคู่สมรส (กรณีคู่สมรสไม่ได้ไปทำจำนองด้วยตนเอง) </li>
                          <li><u>ผู้มีชื่อในเอกสารลงนามรับรองสำเนาถูกต้องทุกฉบับ และต้องเป็นลายเซ็นเดียวกับ ลายเซ็นที่ให้ไว้ต่อที่ดิน ในการทำสัญญาจำนองโฉนดที่ดินเดียวกันก่อนหน้านี้ ระบุ ใช้เพื่อเป็นเอกสารประกอบการทำจำนอง เท่านั้น</u></li>
                        </ul>
                      </td>
                      <td>1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด<br />
                        1 ชุด
                      </td>
                    </tr>
                    <tr>
                      <td>เอกสารประกอบการเบิกงวด
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>1. สมาชิกส่งภาพถ่ายรายละเอียดงานซ่อมแซมที่เสร็จสมบูรณ์ เปรียบเทียบกับก่อนการซ่อมแซมตามรายการที่ระบุในเอกสารการขอกู้</li>
                          <li>2. สหกรณ์ตรวจสอบรายละเอียดความสำเร็จของงานตามรายการที่ระบุในเอกสารการขอกู้</li>
                          <li>3. สหกรณ์อนุมัติการจ่ายเงินงวดที่สองให้สมาชิกเมื่อเอกสารถูกต้องครบถ้วน</li>
                        </ul>
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PersonalLoanforRenovate;
